import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nairaCurrency',
  standalone: false
})
export class NairaCurrencyPipe implements PipeTransform {

  transform(value: number): string {
    if (value === null || value === undefined) {
      return '';
    }

    const formattedValue = value.toLocaleString('en-NG', {
      style: 'currency',
      currency: 'NGN',
      minimumFractionDigits: 2
    });

    return formattedValue;
  }
}
